<template>
  <v-col class="pa-6">
    <div v-if="!viewingRequest">
      <v-row class="ma-0 mb-4">
        <v-col cols="12">
          <v-tabs v-model="activeTab" background-color="transparent" slider-color="#4390c0">
            <v-tab>
              <v-icon left>mdi-account</v-icon>
              Clients ({{ clientRequests.length }})
            </v-tab>
            <v-tab>
              <v-icon left>mdi-doctor</v-icon>
              Doctors ({{ doctorRequests.length }})
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <v-col cols="12" md="3">
          <v-text-field
            class="input"
            label="Search..."
            prepend-inner-icon="mdi-magnify"
            v-model="search"
            rounded
            :hide-details="true"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            class="input"
            label="Status"
            :items="statusOptions"
            v-model="selectedStatus"
            item-text="text"
            item-value="value"
            rounded
            :hide-details="true"
          ></v-select>
        </v-col>
      </v-row>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-row justify="center">
            <v-data-table
              style="width: 100%"
              :headers="headers"
              :items="filteredClientRequests"
              :items-per-page="10"
              class="elevation-1 mt-4 ml-4 mr-8"
              no-data-text=""
            >
              <template v-slot:item.name="{ item }">
                <td>{{ item.name }} {{ item.surname || "" }}</td>
              </template>
              <template v-slot:item.reason="{ item }">
                <td>{{ item.reasonLabel }}</td>
              </template>
              <template v-slot:item.status="{ item }">
                <td>
                  <v-chip
                    class="capatilize"
                    :color="statusColor(item.status || 'pending')"
                    dark
                  >
                    {{ item.status || "pending" }}
                  </v-chip>
                </td>
              </template>
              <template v-slot:item.action="{ item }">
                <td>
                  <v-icon color="#4390c0" @click="viewRequest(item)">mdi-eye</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <v-row justify="center">
            <v-data-table
              style="width: 100%"
              :headers="headers"
              :items="filteredDoctorRequests"
              :items-per-page="10"
              class="elevation-1 mt-4 ml-4 mr-8"
              no-data-text=""
            >
              <template v-slot:item.name="{ item }">
                <td>{{ item.name }} {{ item.surname || "" }}</td>
              </template>
              <template v-slot:item.reason="{ item }">
                <td>{{ item.reasonLabel }}</td>
              </template>
              <template v-slot:item.status="{ item }">
                <td>
                  <v-chip
                    class="capatilize"
                    :color="statusColor(item.status || 'pending')"
                    dark
                  >
                    {{ item.status || "pending" }}
                  </v-chip>
                </td>
              </template>
              <template v-slot:item.action="{ item }">
                <td>
                  <v-icon color="#4390c0" @click="viewRequest(item)">mdi-eye</v-icon>
                </td>
              </template>
            </v-data-table>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <div v-else>
      <v-row class="ma-2">
        <v-col cols="12" md="6">
          <v-row class="mb-2">
            <v-icon class="black-color" @click="close()">
              mdi-arrow-left
            </v-icon>
            <h4 class="grey-color mx-4" style="font-weight: 500">
              Data Deletion Request
            </h4>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12">
          <div class="white-card pa-8">
            <v-row justify="space-between" class="ma-0">
              <div>
                <h2 class="fs400 mb-2">{{ selectedRequest.name }} {{ selectedRequest.surname || "" }}</h2>
                <p class="grey-color">
                  {{ selectedRequest.reasonLabel || "No reason supplied" }}
                </p>
              </div>
              <div class="text-right">
                <v-chip
                  class="status-chip mx-2 mt-1"
                  style="text-transform: capitalize"
                  :color="statusColor(selectedRequest.status || 'pending')"
                  dark
                >
                  {{ selectedRequest.status || "pending" }}
                </v-chip>
                <p class="grey-color mt-2">
                  {{ formatTimestamp(selectedRequest.timestamp) }}
                </p>
              </div>
            </v-row>
            <v-row class="mt-6">
              <v-col cols="12" md="4">
                <p class="info-label">Email</p>
                <p class="info-value">{{ selectedRequest.email || "N/A" }}</p>
              </v-col>
              <v-col cols="12" md="4">
                <p class="info-label">Phone</p>
                <p class="info-value">
                  {{ selectedRequest.CellNo || selectedRequest.cellNo || selectedRequest.userData?.phone || "N/A" }}
                </p>
              </v-col>
              <v-col cols="12" md="4">
                <p class="info-label">User Type</p>
                <p class="info-value">
                  {{ selectedRequest.userType || "Unknown" }}
                </p>
              </v-col>
            </v-row>
            <v-row class="mt-6">
              <v-col cols="12" md="6">
                <v-btn
                  color="#e022d1"
                  class="pink-btn mb-4"
                  large
                  rounded
                  dark
                  :loading="actionLoading.disable"
                  @click="disableAuthUser"
                >
                  Disable In Auth
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-btn
                  color="#d32f2f"
                  class="mb-4"
                  large
                  rounded
                  dark
                  :loading="actionLoading.delete"
                  @click="deleteAuthUser"
                >
                  Delete From Auth
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular :size="100" color="#4390c0" indeterminate />
      </v-overlay>
    </v-row>
    <v-dialog v-model="promptDialog" max-width="480">
      <v-card class="pa-8" elevation="4" shaped style="border-radius: 24px">
        <v-card-text class="text-center">
          <v-icon size="96" color="red" v-if="promptType == 'error'">
            mdi-alert-circle
          </v-icon>
          <v-icon size="96" color="green" v-if="promptType == 'success'">
            mdi-check-circle
          </v-icon>
          <div class="text-h5 my-6" v-if="promptType == 'error'">Error</div>
          <div class="text-h5 my-6" v-if="promptType == 'success'">Success</div>
          <div class="body-1 text-h6">{{ promptMessage }}</div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            color="black"
            dark
            depressed
            large
            style="border-radius: 24px"
            @click="promptDialog = false"
          >
            CLOSE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import {
  collection,
  doc,
  getFirestore,
  onSnapshot,
  query,
  updateDoc,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../../firebaseConfig";
import { logAction } from "@/utils/firestoreUtil";
import emailjs from "@emailjs/browser";


const db = getFirestore(firebaseApp);
const cloudFunctions = getFunctions(firebaseApp);

export default {
  name: "DataDeletionRequests",
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "User Type", value: "userType" },
        { text: "Reason", value: "reasonLabel", sortable: false },
        { text: "Status", value: "status" },
        { text: "Action", value: "action", sortable: false },
      ],
      statusOptions: [
        { text: "All", value: "all" },
        { text: "Pending", value: "pending" },
        { text: "Disabled", value: "disabled" },
        { text: "Deleted", value: "deleted" },
        { text: "Completed", value: "completed" },
      ],
      requests: [],
      search: "",
      selectedStatus: "pending",
      activeTab: 0,
      viewingRequest: false,
      selectedRequest: null,
      cachedRequestId: null,
      loading: false,
      promptDialog: false,
      promptMessage: "",
      promptType: "",
      unsubscribeRequests: null,
      actionLoading: {
        disable: false,
        delete: false,
      },
    };
  },
  created() {
    this.cachedRequestId = localStorage.getItem("ViewedDeletionRequest");
    this.getRequests();
  },
  beforeDestroy() {
    if (this.unsubscribeRequests) {
      this.unsubscribeRequests();
    }
  },
  computed: {
    doctorRequests() {
      return this.requests.filter((req) => req.userType === "Doctor");
    },
    clientRequests() {
      return this.requests.filter((req) => req.userType !== "Doctor");
    },
    filteredDoctorRequests() {
      return this.filterRequests(this.doctorRequests);
    },
    filteredClientRequests() {
      return this.filterRequests(this.clientRequests);
    },
    storeUser() {
      return this.$store.state.user || {};
    },
  },
  methods: {
    async sendDeletionEmail(request) {
      const templateParams = {
        userName: `${request.name} ${request.surname || ""}`,
        userEmail: request.email || "N/A",
        userPhone: request.CellNo || request.userData?.phone || "N/A",
        effectiveDate: new Date().toLocaleDateString(), // or another date you want
        deletionReason: request.reasonLabel || "Not provided",
        deleted_by: this.storeUser.email,
      };


      try {
        await emailjs.send(
          "service_zsv6bhg",
          "template_9khxkcy",
          templateParams,
          "-QV030q2Dw53wMHro"
        );
        console.log("Deletion email sent successfully.");
      } catch (error) {
        console.error("EmailJS Error:", error);
      }
    },

    filterRequests(requests) {
      const searchTerm = this.search.toLowerCase();
      return requests
        .filter((request) => {
          if (!this.selectedStatus || this.selectedStatus === "all") {
            return true;
          }
          return (request.status || "pending") === this.selectedStatus;
        })
        .filter((request) => {
          if (!searchTerm) return true;
          const haystack = [
            request.name,
            request.email,
            request.userType,
            request.reasonLabel,
            request.CellNo,
            request.idNumber,
            request.userId,
            request.uid,
            request.userData?.name,
            request.userData?.surname,
            request.userData?.email,
            request.userData?.phone,
          ]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();
          return haystack.includes(searchTerm);
        });
    },
    getRequests() {
      try {
        const q = query(collection(db, "deletionRequests"));
        this.loading = true;
        console.log("Fetching data deletion requests from collection: deletionRequests");
        
        this.unsubscribeRequests = onSnapshot(
          q,
          (snapshot) => {
            console.log("Snapshot received, size:", snapshot.size);
            const requests = [];
            snapshot.forEach((docSnap) => {
              const data = docSnap.data();
              
              // Check if userData exists (clients) or use root level (doctors)
              const userData = data.userData && typeof data.userData === 'object' ? data.userData : data;
              const isClient = data.userData && typeof data.userData === 'object';
              
              requests.push({
                id: docSnap.id,
                ...data,
                status: data.status || "pending",
                name: this.buildName(userData),
                surname: userData.surname || userData.userSurname || data.surname || data.userSurname || "",
                email:
                  userData.email ||
                  userData.userEmail ||
                  data.email ||
                  data.userEmail ||
                  null,
                userType: userData.userType || data.userType || data.accountType || (isClient ? "Client" : "Unknown"),
                reasonLabel: data.customReason || data.reason || "Not provided",
                // Store userData for detail view
                userData: userData,
                // Store phone for display
                CellNo: userData.phone || userData.CellNo || data.CellNo || null,
              });
            });
            console.log("Processed requests:", requests.length);
            this.requests = requests;
            this.loading = false;

            if (this.cachedRequestId) {
              const cached = this.requests.find(
                (req) => req.id === this.cachedRequestId
              );
              if (cached) {
                this.viewRequest(cached);
              } else {
                localStorage.removeItem("ViewedDeletionRequest");
                this.cachedRequestId = null;
              }
            }
          },
          (error) => {
            console.error("Error fetching data deletion requests:", error);
            this.loading = false;
            this.showPrompt(
              "error",
              `Failed to load requests: ${error.message || "Unknown error"}`
            );
          }
        );
      } catch (error) {
        this.loading = false;
        console.error("Error setting up request listener:", error);
        this.showPrompt(
          "error",
          `Failed to initialize: ${error.message || "Unknown error"}`
        );
      }
    },
    buildName(data = {}) {
      if (data.displayName) return data.displayName;
      return data.name || "Unknown";
    },
    viewRequest(item) {
      this.selectedRequest = item;
      this.viewingRequest = true;
      this.cachedRequestId = item.id;
      localStorage.setItem("ViewedDeletionRequest", item.id);
    },
    close() {
      this.viewingRequest = false;
      this.selectedRequest = null;
      this.cachedRequestId = null;
      localStorage.removeItem("ViewedDeletionRequest");
    },
    formatTimestamp(timestamp) {
      if (!timestamp) return "No timestamp";
      try {
        if (timestamp.toDate) {
          return timestamp.toDate().toLocaleString();
        }
        if (
          typeof timestamp === "object" &&
          typeof timestamp.seconds === "number"
        ) {
          return new Date(timestamp.seconds * 1000).toLocaleString();
        }
        return new Date(timestamp).toLocaleString();
      } catch (error) {
        return timestamp;
      }
    },
    statusColor(status) {
      switch (status) {
        case "deleted":
          return "#DC143C";
        case "disabled":
          return "#4390c0";
        case "completed":
          return "green";
        case "pending":
        default:
          return "#ff9800";
      }
    },
    async disableAuthUser() {
      if (!this.selectedRequest) return;
      const email =
        this.selectedRequest.email ||
        this.selectedRequest.userEmail ||
        this.selectedRequest.contactEmail ||
        this.selectedRequest.userData?.email ||
        this.selectedRequest.userData?.userEmail;

      if (!email) {
        this.showPrompt("error", "No email address found for this user.");
        return;
      }

      if (
        !confirm(
          `Disable authentication access for ${this.selectedRequest.name}?`
        )
      ) {
        return;
      }

      try {
        this.actionLoading.disable = true;
        const callable = httpsCallable(cloudFunctions, "setAuthUserDisabled");
        const result = await callable({ email, disabled: true });

        if (result.data && result.data.error) {
          throw new Error(result.data.error);
        }

        await this.updateRequestStatus("disabled");

        await logAction(
          "Data Deletion",
          "Auth Disabled",
          this.storeUser.email,
          `${this.storeUser.email} disabled auth for ${email}`
        );

        this.showPrompt(
          "success",
          "User access has been disabled in Firebase Authentication."
        );
      } catch (error) {
        console.log("error: ", error);
        this.showPrompt(
          "error",
          error.message || "Failed to disable user in Authentication."
        );
      } finally {
        this.actionLoading.disable = false;
      }
    },
      async deleteAuthUser() {
        if (!this.selectedRequest) return;

        const email =
          this.selectedRequest.email ||
          this.selectedRequest.userEmail ||
          this.selectedRequest.contactEmail ||
          this.selectedRequest.userData?.email ||
          this.selectedRequest.userData?.userEmail;

        if (!email) {
          this.showPrompt("error", "No email address found for this user.");
          return;
        }

        if (!confirm(
          `This will delete ${this.selectedRequest.name} from Firebase Authentication but keep their records. Continue?`
        )) {
          return;
        }

        try {
          this.actionLoading.delete = true;
          const callable = httpsCallable(cloudFunctions, "removeAuthUser");
          const result = await callable({ email });

          if (result.data && result.data.error) {
            throw new Error(result.data.error);
          }

          // Update Firestore status
          await this.updateRequestStatus("deleted");

          // Log action
          await logAction(
            "Data Deletion",
            "Auth Deleted",
            this.storeUser.email,
            `${this.storeUser.email} deleted auth for ${email}`
          );

          
          await this.sendDeletionEmail(this.selectedRequest);

          this.showPrompt(
            "success",
            "User deleted from Firebase Authentication. Notification email sent."
          );
        } catch (error) {
          console.log("error: ", error);
          this.showPrompt(
            "error",
            error.message || "Failed to delete user from Authentication."
          );
        } finally {
          this.actionLoading.delete = false;
        }
      },

    async updateRequestStatus(status) {
      if (!this.selectedRequest?.id) return;
      try {
        const requestRef = doc(
          db,
          "deletionRequests",
          this.selectedRequest.id
        );
        await updateDoc(requestRef, {
          status,
          processedAt: new Date().toISOString(),
          processedBy: this.storeUser.email || null,
        });
      } catch (error) {
        console.log("error: ", error);
      }
    },
    showPrompt(type, message) {
      this.promptType = type;
      this.promptMessage = message;
      this.promptDialog = true;
    },
  },
};
</script>

<style scoped>
.info-label {
  font-weight: 600;
  color: grey;
}

.info-value {
  font-size: 16px;
  font-weight: 500;
}

.break-word {
  word-break: break-word;
  white-space: pre-line;
}
</style>

